export const colors = {
  transparent: "transparent",
  // Brand Colors
  greenDark: "#006B3F",
  greenLight: "#079D56",
  yellow: "#FFB822",
  lilac: "#AC41D8",
  red: "#E04C36",

  // Neutral Colors
  white: "#FFFFFF",
  white2: "#EDF2F0",
  gray1: "#434645",
  gray2: "#5D615F",
  gray3: "#D9DDDB",
  gray4: "#999E9C",
  gray5: "#242625",

  green: '#006B3F',
  orange: '#FF8B22',
  orange2: '#F1892B',
  orange3: '#F3B780',
  offwhite: '#E8E3DD',
  black: '#242625',
  error: '#E04C36',
  gray: "#D4CCC4",
  darkPure: "#0B0B0B",
  //usage: color: ${colors.red2};
};

export const sizes = {
  mobileSmall: 393,
  mobile: 768,
  tablet: 1024,
  desktop: 1440,
};

export const margins = {
  mobile: 24,
  tablet: 48,
  desktop: 114,
};


export const devices = {
  mobileSmall: `(max-width: ${sizes.mobile - 1}px)`,
  mobile: `(max-width: ${sizes.mobile}px)`,
  tablet: `(min-width: ${sizes.mobile}px) and (max-width: ${sizes.tablet}px)`,
  desktop: `(min-width: ${sizes.tablet}px)`

  //usage: @media ${devices.desktop}
};

//Novo Conhecer

export const content = {
  desktop: 1208,
  desktopSmall: 964,
}

export const sizesNovo = {
  mobile: 768,
  tablet: 1024,
  desktop: 1440
}

export const marginsNovo = {
  mobile: 24,
  tablet: 48,
  desktop: 116,
}

export const devicesNovo = {
  mobile: `(max-width: ${sizesNovo.mobile - 1}px)`,
  tablet: `(min-width: ${sizesNovo.mobile}px) and (max-width: ${sizesNovo.tablet}px)`,
  desktop: `(min-width: ${sizesNovo.tablet}px)`,
  smallDesktop: `(min-width: ${sizesNovo.mobile + 1}px)`
}

